<!-- EM_MO_SB_027  자동충전 - 충전중 -->
<template>
  <div>
    <div class="charging-detail-top">
      <span class="card-image shadow" :style="{ backgroundImage:'url('+cardInfo.thumbnailImageUrl+')'}"></span>
      <div class="mb-24">
        <!--<em>{{autoReloadData.remainCash | comma}}</em>-->
        <!-- 첫 하한선 자동충전 설정 시 즉시 충전 비동기 처리로 잔액 제거 250423-->
<!--        <em>{{Number(autoReloadData.remainCash).toLocaleString()}}</em>-->
        <br>
        <strong>{{ cardInfo.prepaidCardNickName != null? cardInfo.prepaidCardNickName : cardInfo.giftMessage != null? cardInfo.giftMessage : '' }}</strong>
        <span>구매일<small>{{autoReloadData.issueDate}}</small></span>
      </div>
      <bg-gray-text class="mb-20" text="자동충전을 설정 하셨습니다."></bg-gray-text>
    </div>
    <gray-line class="absolute"></gray-line>
    <div class="order-text-box px-20">
      <strong>충전 정보</strong>
      <div>
        <em>충전방식</em>
        <span v-if="autoReloadData.autoReloadType === 'AMOUNT'">하한선 자동충전</span>
        <span v-if="autoReloadData.autoReloadType === 'DATE'">월 정액 자동충전</span>
      </div>
      <div v-if="autoReloadData.autoReloadType === 'AMOUNT'">
        <em>기준잔액</em>
        <span v-if="autoReloadData.autoReloadBasedAmountType">{{autoReloadData.autoReloadBasedAmountType | changeBasedAmountType}}만원</span>
      </div>
      <div v-else>
        <em>자동 충전일</em>
        <span v-for="(item, index) in autoReloadData.autoReloadDay" :key="`autoReloadDay_${index}`">
                매월 {{item === 'ED' ? '말' : item }}일<template v-if="index !== autoReloadData.autoReloadDay.length - 1">, &nbsp;</template>
              </span>
      </div>
      <div>
        <em>자동 충전 금액</em>
        <span v-if="autoReloadData.autoReloadAmount">{{autoReloadData.autoReloadAmount / 10000}}만원</span>
      </div>
    </div>
    <gray-line class="absolute"></gray-line>
    <div class="autocharging-precautions">
      <div>
        <span class="icon-tool-tip"></span>
        <strong>이마티콘 자동 충전 유의사항</strong>
      </div>
      <ul>
        <li>
          <p><span class="precautions-dot"></span><em>하한선 자동충전 설정시 즉시충전 됩니다. (최초설정 1회 限)</em></p>
        </li>
        <li>
          <p><span class="precautions-dot"></span><em>카드 분실 신고 시 자동 충전 설정은 즉시 자동 해제됩니다.</em></p>
        </li>
        <li>
          <p><span class="precautions-dot"></span><em>월 정액 자동충전시 당일 오전 10시부터 순차적으로 충전 진행됩니다.</em></p>
        </li>
        <li>
          <p><span class="precautions-dot"></span><em>다음의 경우에 자동 충전 설정은 자동으로 해제됩니다.</em></p>
        </li>
        <li>
          <p class="ml-11"><span class="precautions-dash">- </span><em>자동 충전에 의해 결제시도 시, 연속으로 2회 이상 카드사나 통신사 측의 승인이 거부되는 경우</em></p>
        </li>
        <li>
          <p class="ml-11"><span class="precautions-dash">- </span><em>사용중인 카드를 등록해지하는 경우</em></p>
        </li>
        <li>
          <p class="ml-11"><span class="precautions-dash">- </span><em>분실, 고장 등의 사유로 자동 충전 설정이 된 카드를 중지 신청하는 경우</em></p>
        </li>
        <li>
          <p class="ml-11"><span class="precautions-dash">- </span><em>회원탈퇴로 이마티콘 서비스를 더 이상 이용하지 않는 경우</em></p>
        </li>
        <li>
          <p class="ml-11"><span class="precautions-dash">- </span><em>충전 이후 사용 이력이 없는 경우 온라인에서 구매/충전 취소가 가능합니다.</em></p>
        </li>
        <li>
          <p><span class="precautions-dot"></span><em>이마티콘 충전시 기존 잔액 + 충전금액 합계가 50만원이 초과되는 경우 충전이 되지 않습니다.</em></p>
        </li>
        <li v-if="setPrecautionsEnable()">
          <p><span class="precautions-dot"></span><em>이마티콘은 월 최대 500만원 구매 가능합니다.<br>
            (구매/선물/충전/자동충전 합산액 기준)<br>
            매월 1일에 구매 가능 한도가 자동 복원됩니다.</em></p>
        </li>
        <li>
          <p><span class="precautions-dot"></span><em>충전시 제공되는 혜택은 운영 정책에 따라 변경될 수 있습니다.</em></p>
        </li>
      </ul>
    </div>
    <div class="charging-button-wrap absolute bottom-sticky">
      <div class="button-wrap">
        <button @click="cancelBtn()" class="button-bg-gray">해지하기</button>
        <button @click="changeBtn()" class="button-bg-yellow">변경하기</button>
      </div>
      <!--            <bottom-button class="button-style" :buttonArray="buttonArray" @sendEvent="btnEvent($event)"></bottom-button>-->
    </div>
    <charging-popup @emitPopValue="popupEvent($event)" v-if="showQuestionPop" />
    <charging-popup2 @emitPopValue="popupEvent($event)" v-if="showCancelPop" :message="popUpMessage" />
  </div>
</template>

<script>
import GrayLine from '@/components/common/GrayLine.vue';
import BottomButton from '@/components/common/BottomButton.vue';
import SelectBoard from '@/components/common/SelectBoard.vue';
import SelectPayment from '@/components/common/SelectPayment.vue';
import BgGrayText from '@/components/common/BgGrayText.vue';

import ChargingPopup from './chargingPopup.vue';
import ChargingPopup2 from './chargingPopup2.vue';
import apiList from "@/api/apiList";

export default {
  name: 'Charging',
  components: { GrayLine, BottomButton, SelectBoard, SelectPayment, BgGrayText, ChargingPopup, ChargingPopup2},
  data() {
    // selectBoardList: <select-board></select-board> 컴포넌트에게 전달할 프롭스
    return {
      showQuestionPop: false,
      showCancelPop: false,
      autoReloadData: { // 자동충전 설정 조회
        prepaidCardNo: '', // 선불카드번호
        billKey: '', // 빌키
        autoReloadType: '', // 자동충전유형
        autoReloadAmountType: '', // 자동충전금액유형
        autoReloadAmount: '', // 자동충전금액 > 직접 입력 선택 시 활성화
        autoReloadBasedAmountType: '', // 자동충전기준금액유형
        autoReloadDay: [], // 자동충전일자(2개 선택가능)
        autoReloadPayToolCode: '', // 자동충전결제수단코드
        autoReloadChangeDateTime: '',
        autoReload: '',
        giftMessage: '',
        issueDate: '',
        remainCash: ''
      },
      prepaidCardNo: '',
      // prepaidCardNo: '0254570014470400',
      mberNo: this.$store.state.mberInfo.mberNo,
      //mberNo: 'C21743839',
      pgCode: this.$store.state.autoReloadPgCode,
      lastDay: '',
      popUpMessage: '',
      cardInfo: {}
    }
  },
  filters: {
    /**
     * 숫자형 , 추가
     * @param num (금액형으로 변경할) 수(금액)
     */
    comma(num) {
      return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    /**
     * 기준금액타입에 따른 금액 노출
     * @param code 자동충전기준금액타입 코드
     */
    changeBasedAmountType(code) {
      let basedAmount
      switch (code) {
        case 'W10K' :
          basedAmount = 1
          break;
        case 'W20K' :
          basedAmount = 2
          break;
        case 'W30K' :
          basedAmount = 3
          break;
        case 'W50K' :
          basedAmount = 5
          break;
        case 'W100K' :
          basedAmount = 10
          break;
      }
      return basedAmount
    },
  },
  // props: {
  //   prepaidCardNo: {
  //     type: String,
  //     required: true
  //   },
  // },
  /*
    created() {
      let date = new Date();
      let last = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.lastDay = last.getDate();
    },
   */
  mounted() {
    this.$heading('자동 충전')

    // prepaidCardNo가 없다면 에러페이지로 이동
    //const card = {};
    //card.prepaidCardNo = '0254570000007448';
    //card.imageUrl = 'https://mycloudmembership-dev.s3.ap-northeast-2.amazonaws.com/emarticon/public/img/emarticon_image6.png';
    //card.thumbnailImageUrl = 'https://mycloudmembership-dev.s3.ap-northeast-2.amazonaws.com/emarticon/public/img/emarticon_image6.png';
    //const cardInfo = card;
    const cardInfo = this.$route.params.cardInfo;
    if (cardInfo && cardInfo.prepaidCardNo) {
      this.cardInfo = cardInfo
      this.prepaidCardNo = cardInfo.prepaidCardNo;
      this.getAutoReload()
    } else {
      const errorPath = '/error'
      if (this.$route.path !== errorPath) {
        this.$router.push({path: "/error"});
      }
      return;
    }
  },
  methods: {
    /**
     * 자동충전 설정 조회
     *
     */
    async getAutoReload() { // 자동충전 설정 조회
      try {
        // 1. 선불카드번호(이마티콘번호)로 현재 가입된 자동충전정보 조회
        const response = await apiList.getAutoReload({prepaidCardNo: this.prepaidCardNo});
        // 2. 조회 결과에 따른 분기 처리
        // 2-1. 자동충전정보가 존재하지 않는 경우 자동충전설정 화면으로 이동 처리
        // 2-2. 자동충전정보가 존재하는 경우 자동충전설정 정보 설정
        // 2-3. 조회 오류 시 에러페이지로 이동 처리
        if (response.data.code === 'S00000') {
          if (response.data.data.autoReload === false) {
            // 저장된 값이 없으면 자동충전설정 페이지로 넘긴다.
            await this.$router.replace({name: 'autoCharging', params: {cardInfo: this.cardInfo}});
            return
          }
          this.autoReloadData = response.data.data
        }
      } catch (error) {
        await this.$router.replace({path: "/error"});
        // this.$router.push({ path: "/error" });
        console.error(error);
      }
    },

    /**
     * 자동충전 설정 해지버튼 click
     */
    cancelBtn() {
      // 1. 자동충전설정 해지여부
      this.showQuestionPop = true
    },
    /**
     * 자동충전 설정 변경하기 버튼 click
     *  - 자동충전설정(autoCharging)으로 이동
     *  - 선불카드(이마티콘) 정보를 파라미터로 전달 처리
     */
    changeBtn() {
      this.$router.replace({name: 'autoCharging', params: {cardInfo: this.cardInfo}});
    },

    /**
     * 자동충전설정 해지 처리
     *  - 선택한 선불카드(이마티콘)의 자동충전설정정보를 해지 처리
     */
    async putAutoReload() { // 자동충전 설정 수정/해지
      // 1. 자동충전설정 해지 파라미터 설정
      let params = {
        actionType: 'TRMNT', // 수정/해지 구분 (MODIFY : 수정, TRMNT: 해지)
        pgCode: this.pgCode, // pg코드
        billKey: this.autoReloadData.billKey, // 빌키
        autoReloadType: this.autoReloadData.autoReloadType, // 자동충전유형
        autoReloadAmountType: this.autoReloadData.autoReloadAmountType, // 자동충전금액유형
        autoReloadAmount: this.autoReloadData.autoReloadAmount, // 자동충전금액 > 직접 입력 선택 시 활성화
        autoReloadBasedAmountType: this.autoReloadData.autoReloadBasedAmountType, // 자동충전기준금액유형
        autoReloadDay: this.autoReloadData.autoReloadDay, // 자동충전일자(2개 선택가능)
        autoReloadPayToolCode: this.autoReloadData.autoReloadPayToolCode, // 자동충전결제수단코드
        modifyAuthor: this.mberNo, // 수정자
      }
      // 2. 자동충전설정 해지 처리
      // 2-1. 선불카드(이마티콘)의 카드번호와 파라미터로 자동충전설정 해지 실행
      // 2-2. 성공 시 자동충전 해지완료 메세지 실행
      // 2-3. 실패 시 자동충전 해지실패 메세지 실행
      try{
        const response = await apiList.putAutoReload({...params},{prepaidCardNo: this.prepaidCardNo});
        if (response.data.code === 'S00000') {
          this.popUpMessage = '자동충전이 해지 되었습니다'
          this.showCancelPop = true
        }
      } catch (error) {
        this.popUpMessage = '자동충전 해지 실패했습니다'
        this.showCancelPop = true
        console.error(error);
      }
    },

    /**
     * (메시지)팝업 처리
     * @param code 각 메시지의 코드
     */
    popupEvent(code) {
      if (code === 'Y') {
        this.showQuestionPop = false
        this.putAutoReload()
      }
      if (code === 'N') {
        this.showQuestionPop = false
      }
      if (code === 'C') {
        this.showCancelPop = false
        this.$router.replace({name: 'home'});
      }
    },
    /**
     * 한도금액설정 유의사항 문구 노출
     */
    setPrecautionsEnable() {
      const today = new Date()
      const beginDate = new Date('2026-01-26T00:00:00');

      if(today > beginDate) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/pages/cards/charging.scss';

.bottom-sticky {
  position: sticky;
  bottom: 0;
}
</style>